module.exports = __webpack_public_path__ + "static/img/websiteLogo.512b83de.png";